// extracted by mini-css-extract-plugin
module.exports = {"imageSpots":"ImageSpots--image-spots--2Nn9N","placeholder":"ImageSpots--placeholder--__MjS","spotContainer":"ImageSpots--spot-container--3b185"};